import React from 'react';
const FacebookIcon = ({ fill, width, height, opacity }) => (
    <svg width={width} height={height} viewBox="0 0 30 30">
        <path
            fill={fill}
            opacity={opacity}
            d="M15,0c4.1,0,7.9,1.7,10.6,4.4C28.3,7.1,30,10.9,30,15c0,4.1-1.7,7.9-4.4,10.6C22.9,28.3,19.1,30,15,30
	c-4.1,0-7.9-1.7-10.6-4.4C1.7,22.9,0,19.1,0,15c0-4.1,1.7-7.9,4.4-10.6C7.1,1.7,10.9,0,15,0L15,0z M24.8,5.2c-2.5-2.5-6-4.1-9.8-4.1
	c-3.8,0-7.3,1.6-9.8,4.1c-2.5,2.5-4.1,6-4.1,9.8c0,3.8,1.6,7.3,4.1,9.8c2.5,2.5,6,4,9.8,4c3.8,0,7.3-1.5,9.8-4c2.5-2.5,4-6,4-9.8
	C28.8,11.2,27.3,7.7,24.8,5.2L24.8,5.2z"
        />
        <path
            fill={fill}
            opacity={opacity}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1,11.9v-1.2c0-0.6,0.4-0.7,0.7-0.7c0.3,0,1.7,0,1.7,0V7.4h-2.4c-2.6,0-3.2,1.9-3.2,3.2v1.4h-1.5v1.9V15H13
	c0,3.5,0,7.7,0,7.7H16c0,0,0-4.2,0-7.7h2.3l0.1-1.2l0.2-1.9H16.1z"
        />
    </svg>
);

export default FacebookIcon;
